import { env as env2 } from '@rsmus/react-env-image'

/*
    The following are values found in either the .env files or in the environment variables on the machine.
    Environment variables from the machine are preferred, but .env files can be useful in development.  In such
    cases, use .env.development, since that will not propagate to the production environment.
*/

// This is a temporary work around to allow tests to succeed.  The current env function will throw
//  errors if the window object doesn't have a config property.  The offending NPM package should be
//  updated soon, and this if-block can be removed at that time.
let env = env2
if ((window as any) != null && (window as any).config == null) {
  env = function() {
    return undefined
  }
}

export const REACT_APP_APPINSIGHTSINSTRUMENTATIONKEY = env(
  'REACT_APP_APPINSIGHTSINSTRUMENTATIONKEY'
)

export const REACT_APP_GLOBALMAJORMINORBUILDREVISION = env(
  'REACT_APP_GLOBALMAJORMINORBUILDREVISION'
)

export const REACT_APP_IDMAUTHENTICATIONCLIENTID = env(
  'REACT_APP_IDMAUTHENTICATIONCLIENTID'
)

export const REACT_APP_IDMAUTHENTICATIONAUTHORITY = env(
  'REACT_APP_IDMAUTHENTICATIONAUTHORITY'
)

export const REACT_APP_IDMAUTHENTICATIONEULASERVICEURL = env(
  'REACT_APP_IDMAUTHENTICATIONEULASERVICEURL'
)

export const REACT_APP_OIDCSILENTREFRESHOFFSETTIMEINSECONDS = env(
  'REACT_APP_OIDCSILENTREFRESHOFFSETTIMEINSECONDS'
)

export const REACT_APP_GLOBALUNAUTHORIZEDREDIRECTURL = env(
  'REACT_APP_GLOBALUNAUTHORIZEDREDIRECTURL'
)

export const REACT_APP_AUTHORIZATIONSERVICEURL = env(
  'REACT_APP_AUTHORIZATIONSERVICEURL'
)

export const REACT_APP_HOSTURL = env('REACT_APP_HOSTURL')

export const REACT_APP_ENGAGEMENTMANAGERURL = env(
  'REACT_APP_ENGAGEMENTMANAGERURL'
)

export const REACT_APP_GLOBALIDLETIMEOUTINSECS = env(
  'REACT_APP_GLOBALIDLETIMEOUTINSECS'
)

export const REACT_APP_GLOBALMODALTIMEOUTINSECS = env(
  'REACT_APP_GLOBALMODALTIMEOUTINSECS'
)

export const REACT_APP_LOGOUTREDIRECTURL = env('REACT_APP_LOGOUTREDIRECTURL')

export const REACT_APP_GLOBALGETUSERTIMEOUTINSECS = env(
  'REACT_APP_GLOBALGETUSERTIMEOUTINSECS'
)

export const REACT_APP_GLOBALHTTPREQUESTTIMEOUTINSECS = env(
  'REACT_APP_GLOBALHTTPREQUESTTIMEOUTINSECS'
)

export const REACT_APP_GLOBALFILEDOWNLOADTIMEOUTINSECS = env(
  'REACT_APP_GLOBALFILEDOWNLOADTIMEOUTINSECS'
)

export const REACT_APP_ANSWERSAVEDELAY = env('REACT_APP_ANSWERSAVEDELAY')

export const REACT_APP_ASYNCOPERATIONPOLLINGTIMEOUTINSECS = env(
  'REACT_APP_ASYNCOPERATIONPOLLINGTIMEOUTINSECS'
)

export const REACT_APP_ASYNCOPERATIONREQUESTTIMEOUT = env(
  'REACT_APP_ASYNCOPERATIONREQUESTTIMEOUT'
)

export const REACT_APP_PINGAUTHSCOPES = env('REACT_APP_PINGAUTHSCOPES')

export const REACT_APP_TSAAGGREGATORURL = env('REACT_APP_TSAAGGREGATORURL')

export const REACT_APP_NOAUTH = env('REACT_APP_NOAUTH')

export const REACT_APP_INTERNALUSERGROUPS = env('REACT_APP_INTERNALUSERGROUPS')

export const REACT_APP_ENABLEIMMUTABLESTATEINVARIANT = env(
  'REACT_APP_ENABLEIMMUTABLESTATEINVARIANT'
)

export const REACT_APP_TSAAPIBASEURL = env('REACT_APP_TSAAPIBASEURL')

export const REACT_APP_TERMSOFSERVICEID = env('REACT_APP_TERMSOFSERVICEID')
